import moment from "moment";

/** @typedef {import('../types/anomalyTimeSeries.types').TimeSeriesDataPoint} TimeSeriesDataPoint */

/**
 * @param {TimeSeriesDataPoint[]} dataPoints
 */
export const detectPeriodGaps = (dataPoints) => {
  if (dataPoints.length < 2) return { gapAfterIndex: {}, gapMidpoints: [] };

  const intervals = [];
  for (let i = 1; i < dataPoints.length; i++) {
    intervals.push(
      moment(dataPoints[i].period).diff(moment(dataPoints[i - 1].period), "days")
    );
  }
  const sorted = [...intervals].sort((a, b) => a - b);
  const expectedInterval = sorted[Math.floor(sorted.length / 2)] || 31;

  /** @type {Record<number, boolean>} */
  const gapAfterIndex = {};
  /** @type {{ index: number, nextIndex: number }[]} */
  const gapMidpoints = [];

  for (let i = 1; i < dataPoints.length; i++) {
    const diff = moment(dataPoints[i].period).diff(moment(dataPoints[i - 1].period), "days");
    if (diff > expectedInterval * 1.5) {
      gapAfterIndex[i - 1] = true;
      gapMidpoints.push({ index: i - 1, nextIndex: i });
    }
  }

  return { gapAfterIndex, gapMidpoints, expectedInterval };
};

/**
 * @param {TimeSeriesDataPoint[]} dataPoints
 * @param {number} maxCount
 */
export const getHeatmapIntensity = (anomalyCount, maxCount) => {
  if (!anomalyCount || !maxCount) return 0;
  return Math.min(1, anomalyCount / maxCount);
};

/**
 * @param {TimeSeriesDataPoint[]} dataPoints
 */
export const getMaxAnomalyCount = (dataPoints) =>
  Math.max(0, ...dataPoints.map((dp) => dp.anomalyCount || 0));
